module.exports = __webpack_public_path__ + "static/media/4.21_preview.58d0c50a.png";